import '@angular/compiler';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageDigital_twinPidComponent } from './page.digital_twin.pid/page.digital_twin.pid.component';
import { PageActuatorComponent } from './page.actuator/page.actuator.component';
import { PageProjectsItemComponent } from './page.projects.item/page.projects.item.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageDigital_twinMcuComponent } from './page.digital_twin.mcu/page.digital_twin.mcu.component';
import { PageDigital_twinKinematicsComponent } from './page.digital_twin.kinematics/page.digital_twin.kinematics.component';
import { PageDigital_twinComponent } from './page.digital_twin/page.digital_twin.component';
import { PageProjectsComponent } from './page.projects/page.projects.component';
import { PageSimulationComponent } from './page.simulation/page.simulation.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageReportsComponent } from './page.reports/page.reports.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "admin/:tab?",
                component: PageAdminComponent,
                "app_id": "page.admin"
            },
            {
                "path": "digital-twin/pid",
                component: PageDigital_twinPidComponent,
                "app_id": "page.digital_twin.pid"
            },
            {
                "path": "actuator",
                component: PageActuatorComponent,
                "app_id": "page.actuator"
            },
            {
                "path": "projects/:id/:tab?",
                component: PageProjectsItemComponent,
                "app_id": "page.projects.item"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "digital-twin/mcu",
                component: PageDigital_twinMcuComponent,
                "app_id": "page.digital_twin.mcu"
            },
            {
                "path": "digital-twin/kinematics",
                component: PageDigital_twinKinematicsComponent,
                "app_id": "page.digital_twin.kinematics"
            },
            {
                "path": "digital-twin",
                component: PageDigital_twinComponent,
                "app_id": "page.digital_twin"
            },
            {
                "path": "projects",
                component: PageProjectsComponent,
                "app_id": "page.projects"
            },
            {
                "path": "simulation",
                component: PageSimulationComponent,
                "app_id": "page.simulation"
            },
            {
                "path": "reports/:id?",
                component: PageReportsComponent,
                "app_id": "page.reports"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }